import { render, staticRenderFns } from "./CompDiversityArticlesCard.vue?vue&type=template&id=f64a9090"
import script from "./CompDiversityArticlesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompDiversityArticlesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports